module.exports = __webpack_public_path__ + "img/smoke_of_deceit.f931a6d9.png";